import { FunctionComponent } from "react";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useViewport } from "@utils/breakpoints-helper";

interface BasicModalProps {
  title?: string | JSX.Element;
  icon?: JSX.Element;
  visible: boolean;
  onOk?: () => void;
  onCancel: () => void;
  children: string | JSX.Element;
  className?: string;
  isBody?: boolean;
  footer?: JSX.Element | null;
}

const InfoModal: FunctionComponent<BasicModalProps> = ({
  title,
  icon,
  visible,
  onOk,
  onCancel,
  children,
  className = "",
  isBody,
}) => {
  const { width } = useViewport();

  return (
    <>
      <Modal
        centered
        title={title}
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        className={`app-modal info-modal ${
          isBody ? "body-modal" : ""
        } ${className}`}
        closable={false}
        footer={null}
        wrapClassName={isBody ? "" : "modal-aside"}
        maskStyle={
          !isBody
            ? width >= 992
              ? {
                  top: "114px",
                  maxWidth: "460px",
                  width: "100%",
                  right: "unset",
                }
              : width >= 768
              ? {
                  top: "88px",
                  maxWidth: "340px",
                  width: "100%",
                  right: "unset",
                }
              : {
                  top: "0",
                }
            : {}
        }
      >
        <button className="close-button" onClick={onCancel}>
          <CloseOutlined size={48} />
        </button>
        <div className="info-modal-container">
          {icon ? icon : <div className={"info-icon-container"}>?</div>}
          <div className={"info-content"}>{children}</div>
        </div>
      </Modal>
    </>
  );
};

export default InfoModal;
